import { render, staticRenderFns } from "./CustomerReportAdd.vue?vue&type=template&id=2c88a9b0"
import script from "./CustomerReportAdd.vue?vue&type=script&lang=js"
export * from "./CustomerReportAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports